const minute = 60;
const hour = minute * 60;
const day = hour * 24;

/**
 * 
 * @param {Number} second 
 * @returns {Object} 
 */
export function convertToDate(seconds) {
    return {
        days : Math.floor( seconds / day),
        hours : Math.floor( seconds % day / hour),
        minutes : Math.floor( seconds % hour / minute),
        seconds : Math.floor( seconds % minute)
    }
}

/**
 * 
 * @param {Number} seconds 
 * @returns {String}
 */
export function convertToDateString(seconds){
    const t = convertToDate(seconds);
    t.minutes = t.minutes < 10 ? "0" + t.minutes : t.minutes;
    t.seconds = t.seconds < 10 ? "0" + t.seconds : t.seconds;
    
    return t.days ? `${t.days}天 ${t.hours}时` :
        t.hours ? `${t.hours}:${t.minutes}:${t.seconds}` :
        t.seconds ? `${t.minutes}: ${t.seconds}` : "00:00";
}


// WEBPACK FOOTER //
// ./src/utils/time.js